import React from 'react';
import { motion } from 'framer-motion';
import { CartIcon, ArrowRightIcon } from './icons/Icons';
type CtaButtonProps = {
  label?: string;
  price?: string;
  className?: string;
  fullWidth?: boolean;
};
/**
 * The primary conversion button, reused across the page.
 * Warm amber "fire" gradient-free solid with a subtle animated shimmer
 * highlight and a spring press interaction.
 */
export function CtaButton({
  label = 'SÍ, QUIERO APAGAR EL ARDOR',
  price = 'ACCESO POR $10.99',
  className = '',
  fullWidth = true
}: CtaButtonProps) {
  return <motion.a href="#oferta" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.97
  }} animate={{
    boxShadow: ['0 12px 30px -8px rgba(200,80,20,0.45)', '0 16px 42px -6px rgba(200,80,20,0.65)', '0 12px 30px -8px rgba(200,80,20,0.45)']
  }} transition={{
    boxShadow: {
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`group relative inline-flex ${fullWidth ? 'w-full' : ''} items-center justify-center gap-3 overflow-hidden rounded-2xl bg-[#e0611f] px-6 py-5 text-center font-display font-extrabold uppercase tracking-wide text-white ${className}`} data-id="element-64">
      <span className="pointer-events-none absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/25 to-transparent" data-id="element-65" />
      <CartIcon className="relative h-6 w-6 shrink-0" strokeWidth={2.4} data-id="element-66" />
      <span className="relative flex flex-col items-center leading-tight sm:flex-row sm:gap-2" data-id="element-67">
        <span className="text-base sm:text-lg" data-id="element-68">{label}</span>
        <span className="text-sm font-bold text-amber-100 sm:text-base" data-id="element-69">
          — {price}
        </span>
      </span>
      <ArrowRightIcon className="relative h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1" data-id="element-70" />
    </motion.a>;
}